import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { isEmptyHtml, plainTextLength, sanitizeHtml } from "../../utils/richText";

const TOOLBAR = [
  ["bold"],
  ["link"],
  [{ list: "ordered" }, { list: "bullet" }],
];

const MODULES = {
  toolbar: TOOLBAR,
  clipboard: { matchVisual: false },
};

const FORMATS = ["bold", "link", "list"];

/**
 * Minimal rich-text editor (Bold, Link, Bullets).
 * onChange receives sanitized HTML string ("" when empty).
 */
export default function RichTextEditor({
  value = "",
  onChange,
  placeholder = "",
  rows = 3,
  isInvalid = false,
  disabled = false,
  maxPlainLength,
  className = "",
  id,
}) {
  const minHeight = Math.max(60, Number(rows) * 24);

  const handleChange = (html) => {
    let next = sanitizeHtml(html);
    if (isEmptyHtml(next)) {
      next = "";
    }
    if (maxPlainLength != null && plainTextLength(next) > maxPlainLength) {
      return; // ignore change that exceeds plain-text limit
    }
    if (onChange) onChange(next);
  };

  return (
    <div
      id={id}
      className={`ics-rich-text-editor ${isInvalid ? "is-invalid" : ""} ${className}`.trim()}
      style={{ marginBottom: 0 }}
    >
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={handleChange}
        modules={MODULES}
        formats={FORMATS}
        placeholder={placeholder}
        readOnly={disabled}
        style={{ background: disabled ? "#e9ecef" : "#fff" }}
      />
      <style>{`
        .ics-rich-text-editor .ql-container {
          min-height: ${minHeight}px;
          font-size: 1rem;
          border-bottom-left-radius: 0.25rem;
          border-bottom-right-radius: 0.25rem;
        }
        .ics-rich-text-editor .ql-toolbar {
          border-top-left-radius: 0.25rem;
          border-top-right-radius: 0.25rem;
        }
        .ics-rich-text-editor.is-invalid .ql-toolbar,
        .ics-rich-text-editor.is-invalid .ql-container {
          border-color: #dc3545;
        }
        .ics-rich-text-editor .ql-editor {
          min-height: ${minHeight}px;
        }
        .ics-rich-text-editor .ql-editor.ql-blank::before {
          font-style: normal;
          color: #6c757d;
        }
      `}</style>
    </div>
  );
}
